module.exports = __webpack_public_path__ + "img/show_cn_text_8.a34dd679.png";